import React, { useEffect, useRef } from 'react'
import { CircularProgress } from '@mui/material';
import axios from 'axios';


export default function PayUBoomax() {
    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return; // Prevent second call
        hasCalled.current = true;

        const params = new URL(window.location.href).searchParams;
        const userId = params.get("userid");
        const planId = params.get("plan_id");
        const currency_code = params.get("currency_code");
        const currency_symbol = params.get("currency_symbol");
        const movie = params.get("movie");
        const series = params.get("series");
        const credit_type = params.get("credit_type");
        const payment_id = params.get("payment_id");

        console.log("Parameters", userId, planId, currency_code, currency_symbol, movie, series, credit_type);
        if (userId && planId) {
            paymentInitiatePayU(userId, planId, currency_code, currency_symbol, movie, series, credit_type, payment_id);
        }
    }, [])

    const paymentInitiatePayU = async (userId, planId, currency_code, currency_symbol, movie, series, credit_type, payment_id) => {
        const resData = await axios.post('https://boomaxapi.hn-store.com/api/generate_payu_hash/', {
        // const resData = await axios.post('https://boomaxapi.thehnstore.com/api/generate_payu_hash/', {
            user_id: userId,
            plan: planId,
            currency_code: currency_code,
            currency_symbol: currency_symbol,
            movie: movie,
            series: series,
            credit_type: credit_type,
            txnid: payment_id
            // payment_amount: payment_amount,
        })

        console.log("resData", resData)


        const form = document.createElement("form");
        form.method = "POST";
        // form.action = "https://test.payu.in/_payment"; // Production: https://secure.payu.in/_payment
        form.action = "https://secure.payu.in/_payment"; // Production: https://secure.payu.in/_payment

        const fields = {
            key: resData?.data?.key,
            txnid: resData?.data.txnid,
            amount: resData?.data?.amount,
            productinfo: resData?.data?.productinfo,
            firstname: resData?.data?.firstname,
            email: resData?.data?.email,
            phone: resData?.data?.mobile,
            surl: "https://boomaxapi.hn-store.com/api/payu_payment_verify/",
            furl: "https://boomaxapi.hn-store.com/api/payu_payment_verify/",
            hash: resData?.data?.data,
        };

        Object.keys(fields).forEach((key) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
    }

    return (
        <div
            style={{
                height: "100vh",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <CircularProgress />
        </div>
    )
}
